import { render } from "./ScriptPage.vue?vue&type=template&id=134834ae&ts=true"
import script from "./ScriptPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScriptPage.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/script/ScriptPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "134834ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('134834ae', __exports__)) {
    api.reload('134834ae', __exports__)
  }
  
  module.hot.accept("./ScriptPage.vue?vue&type=template&id=134834ae&ts=true", () => {
    api.rerender('134834ae', render)
  })

}


export default __exports__